import React from 'react';
import * as serializer from 'basic-editor-value-serializer';

function IconSVG(props) {
  const markup = serializer.utilities.node.icon.renderSVG(props.settings, props.attached === true);
  return <span className="icon-svg-content" contentEditable={false} dangerouslySetInnerHTML={{ __html: markup }} />;
}

export function IconAdornment(props) {
  const settings = serializer.utilities.node.icon.readSettings(props.element);
  if (settings === null || settings.position !== props.position) {
    return null;
  }
  return <IconSVG settings={settings} attached={true} />;
}

export default IconSVG;
